export default "__VITE_ASSET__BNL_9rJi__"